module.exports = "\r\n.mat-style\r\n{\r\n    width:400px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/settings/account-mapping/account-mapping.component.css
// module id = ./src/app/components/settings/account-mapping/account-mapping.component.css
// module chunks = main